export const setOldImg = (imagUrl) => {
    return async dispatch => {
        await dispatch({type:"SET_OLDIMG",payload:imagUrl});
    }
}